import { Component, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-kib-component',
  imports: [RouterModule],
  styleUrls: ['./kib.component.css'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <router-outlet></router-outlet>
  `,
})
export class KibComponent {}
